<template>
  <div>
    <multiselect
        v-model="internalSelectedOptions"
        :options="computedOptions"
        :multiple="true"
        :close-on-select="false"
        placeholder="옵션 선택"
        label="name"
        track-by="id"
        class="custom-multiselect"
        @input="emitSelectedOptions"
    />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "AdminInBodyMultiselect",
  components: {
    Multiselect,
  },
  props: {
    externalOptions: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultOptions: [ // 인바디 데이터로 변경
        { id: 1, name: "1" },
        { id: 2, name: "2" },
        { id: 3, name: "3" },
      ],
      internalSelectedOptions: [], // 초기에는 비어 있음
    };
  },

  computed: {
    computedOptions() {
      if (this.externalOptions.length > 0) {
        // 문자열 배열 → 객체 배열로 변환
        return this.externalOptions.map((value) => ({
          id: value,
          name: value,
        }));
      } else {
        return this.defaultOptions;
      }
    },
  },
  methods: {
    emitSelectedOptions() {
      this.$emit("input", this.internalSelectedOptions); // 상위 컴포넌트로 값 전달
    },
  },
  watch: {
    value(newVal) {
      this.internalSelectedOptions = newVal; // 상위에서 변경된 값 동기화
    },
    externalOptions: {
      immediate: true, // 외부 옵션 변경 시 컴포넌트에 반영
      handler(newOptions) {
        if (newOptions.length === 0) {
          this.internalSelectedOptions = []; // externalOptions가 비어 있으면 초기화
        } else {
          // externalOptions가 변경될 경우 선택값도 초기화
          this.internalSelectedOptions = [];
        }
      },
    },
  },
};
</script>

<style scoped>
.custom-multiselect {
  width: auto;
  max-width: 700px;
  margin: 0 auto;
}

::v-deep(.multiselect__tag) {
  background-color: #26336A;
  color: #ffffff;
}
::v-deep(.multiselect__tag-icon:after) {
  color: #ffffff;
}
::v-deep(.multiselect__option--highlight) {
  color: #ffffff ;
  background-color: #26336A;
}
::v-deep(.multiselect__option--highlight:after) {
  background-color: #26336A;
  color: #ffffff;
}

::v-deep(.multiselect__option--selected.multiselect__option--highlight) {
  background-color: #9E1915;
  color: #ffffff;
}

::v-deep(.multiselect__option--selected.multiselect__option--highlight:after) {
  background-color: #9E1915 !important;
  color: #ffffff !important;
}
</style>
